import { font, uTransparentLink } from 'modules/styles';
import styled from 'styled-components';

export const Root = styled.div`
    display: flex;
    flex-flow: column;
    height: 100%;
    width: 100%;
`;

export const SuccessSectionScrollable = styled.div`
    flex: 1;
    overflow-y: auto;
    display: flex;
    flex-flow: column;
`;

export const SuccessContent = styled.div`
    margin-top: 50px;
    margin-bottom: 30px;
    margin-left: 20px;
    margin-right: 20px;
`;

export const SuccessText = styled.div`
    margin-bottom: 50px;
    text-align: center;
    ${font(14, '#000', 'standard')}
`;

export const SuccessDownloadButton = styled.div`
    display: flex;
    justify-content: center;
`;

export const SuccessDownloadLink = styled.a`
    ${uTransparentLink}
`;
